<ng-container *ngIf="context?.content?.componentName; else contentTemplate">
  <div [awpDynamicOutlet]="context?.content?.componentName" (activated)="onActivated($event)">
  </div>
</ng-container>
<ng-template #contentTemplate>
  <div [innerHTML]="context?.content?.pageContent?.content|contentParse:context.properties|safeHtml"></div>
</ng-template>